// @flow
import React from 'react';

import { GustoContainer } from './gusto';

/**
 * @typedef {Object} RouteConfigObject - A configuration object containing a URL path and
 * corresponding component to render when a URL location is matched. This is a recursive data
 * structure with an optional 'routes' field containing an array of route configuration objects.
 * @property {string} path - A URL pattern
 * @property {React.Node} component - A component to be rendered only when the path is matched
 * @property {Array.<RouteConfigObject>} [routes] - Nested routes
 *
 * @note
 * In Angular, a URL pattern consists of a path pattern, optionally followed by '?' and a list
 * of search parameters. Multiple search parameters are separated by '&'. Search parameters do not
 * influence whether or not a URL is matched.
 *
 * URL path strings are shared across AngularJS and React routing systems. If you are planning on
 * using complex patterns for URL matching it is recommended you validate these against both,
 * AngularJS urlMatcher and ReactRouter specs.
 *
 * @see
 * - https://ui-router.github.io/ng1/docs/0.2.15/index.html#/api/ui.router.util.type:UrlMatcher
 * - https://github.com/pillarjs/path-to-regexp
 *
 * Also {@see module:reactRouterProvider} for reference on how React routes are handled in AngularJS
 */

/**
 * CWA routes configuration data.
 *
 * @type {Array.<RouteConfigObject>}
 */

type routeComponentProps = {
  clientId: string,
};

const cwaRoutes = [
  {
    path: '/gusto',
    component: GustoContainer,
  },
];

export default cwaRoutes;
